.cycle-control {
    padding: 1px 18px;
    display: flex;
    flex-direction: column;
    text-wrap: nowrap;
    justify-content: center;
}
